<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-autocomplete v-model="queryForm.platform" :items="platforms" label="平台"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined hide-details clearable>
        </v-autocomplete>
      </v-col>
      <!-- <v-col cols="12" xl="4" lg="4" md="6" sm="6">
        <a-range-picker v-model="queryForm.days" :mode="['date', 'date']" :placeholder="['开始日期', '结束日期']"
          :locale="locale" :allowClear="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" size="large"
          style="width:100%;" />
      </v-col> -->
      <v-col cols="12" xl="2" lg="4" md="6" sm="6">
        <a-range-picker v-model="queryForm.months" :mode="['month', 'month']" :placeholder="['开始月份', '结束月份']"
          :locale="locale" :allowClear="true" format="YYYY-MM" valueFormat="YYYY-MM" size="large" style="width:100%;"
          @change="changeMonth" @panelChange="changeMonthPanel" />
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <!-- <v-text-field v-model="queryForm.target" label="充值对象" dense outlined hide-details clearable>
        </v-text-field> -->
        <v-autocomplete v-model="queryForm.target" :items="targets" label="充值对象"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined hide-details clearable>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <a-space>
          <v-btn @click="getData()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-btn @click="getData('download')" color="indigo" dark tile>
            <v-icon small>mdi-download</v-icon>下载报表
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <div class="d-flex justify-space-between align-center mt-2">
      <a-space>
        <v-btn color="primary" tile @click="getData()">
          <v-icon small>mdi-refresh</v-icon> 刷新
        </v-btn>
      </a-space>
      <a-space>
        <v-btn color="success" tile @click="add">
          <v-icon small>mdi-plus</v-icon> 新增
        </v-btn>
      </a-space>
    </div>
    <v-card tile class="mt-2">
      <p class="text-h6">
        <span v-for="(titem, tindex) in total" :key="tindex">
          {{ titem.target }}-
          <!-- <span class="error--text">充值金额({{ titem.famount }})</span>, -->
          <span class="success--text">资金利息({{ titem.finterest }})</span>,
          <span class="error--text">资金成本({{ titem.fzijincost }})</span>。
        </span>
      </p>
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" expandRowByClick>
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="famount" slot-scope="text, record">
          <span class="error--text text-h6">{{ record.famount }}</span>
        </template>
        <template slot="finterest" slot-scope="text, record">
          <span class="success--text text-h6">{{ record.finterest }}</span>
        </template>
        <template slot="fzijincost" slot-scope="text, record">
          <span class="error--text text-h6">{{ record.fzijincost }}</span>
        </template>
        <template slot="create_time" slot-scope="text, record">
          <p>{{ record.create_time }}</p>
          <p>{{ record.create_by }}</p>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="primary" @click.stop="edit(record._id)">编辑</v-btn>
            <a-popconfirm v-if="record._id" title="删除充值记录" ok-text="确定" cancel-text="取消"
              @confirm.stop="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
          <a-space>
            <v-btn text tile color="primary" @click.stop="getRuleInfo(record._id)">计费规则</v-btn>
          </a-space>
        </template>
        <template slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-table size="small" :columns="sheaders" :data-source="record.interests" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" :scroll="{ x: swidth }" row-key="_id">
            <template slot="itype" slot-scope="text, record">
              <a-tag v-if="record.itype === 'in'" color="#87d068">资金利息</a-tag>
              <a-tag v-if="record.itype === 'out'" color="#ff5500">资金成本</a-tag>
            </template>
            <template slot="type" slot-scope="text, record">
              <a-tag v-if="record.type === 'day'" color="#ff5500">按天</a-tag>
              <a-tag v-if="record.type === 'month'" color="#87d068">按月</a-tag>
            </template>
            <template slot="year_rate" slot-scope="text, record">
              <span v-if="record.year_rate">{{ record.year_rate }}%</span>
            </template>
            <template slot="end" slot-scope="text, record">
              {{ record.end || '-' }}
            </template>
            <template slot="duration" slot-scope="text, record">
              {{ record.months ? record.months + '月' : '' }}
              {{ record.days ? record.days + '天' : '' }}
            </template>
            <template slot="fee" slot-scope="text, record">
              <span :class="{
                'text-h6': true,
                'success--text': record.itype === 'in',
                'error--text': record.itype === 'out',
              }">{{ record.fee }}</span>
            </template>
            <template slot="state" slot-scope="text, record">
              <a-tag v-if="record.state === 0" color="#87d068">计息中</a-tag>
              <a-tag v-if="record.state === 1" color="#ff5500">已停止</a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <a href="javascript:void(0);" @click="showDetail(record._id)">明细</a>
            </template>
          </a-table>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <a-modal :title="title" :visible="modal" :confirm-loading="saving" @ok="save" okText="确定" @cancel="cancelSave"
      cancelText="取消" :cancel-button-props="{ props: { disabled: saving } }" :maskClosable="false" :closable="!saving">
      <a-form-model ref="formRef" :model="form" :rules="rules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14 }">
        <a-form-model-item label="充值平台" prop="platform">
          <a-select v-model="form.platform" :options="platforms" placeholder="请选择" size="large" style="width:100%;"
            :disabled="saving">
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="充值金额" prop="amount">
          <a-input v-model="form.amount" type="number" placeholder="充值金额" suffix="元" size="large" style="width:100%;"
            :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="充值日期" prop="date">
          <a-date-picker v-model="form.date" :locale="locale" :allowClear="false" format="YYYY-MM-DD"
            value-format="YYYY-MM-DD" placeholder="充值日期" size="large" style="width:100%;" :disabled="saving" />
        </a-form-model-item>
        <a-form-model-item label="充值对象" prop="target">
          <a-input v-model="form.target" placeholder="充值对象" size="large" style="width:100%;" :disabled="saving" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="计费规则" :visible="ruleModal" :confirm-loading="saving" @ok="saveRule" okText="确定"
      @cancel="cancelSaveRule" cancelText="取消" :cancel-button-props="{ props: { disabled: saving } }"
      :maskClosable="false" :closable="!saving" :width="750">
      <a-form-model ref="ruleFormRef" :model="ruleForm" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="8">
          <a-col :span="12">
            <div>
              <span style="font-size:16px;">充值平台：</span>
              <span style="font-size:18px;">{{ ruleForm.platform }}</span>
            </div>
            <div>
              <span style="font-size:16px;">充值日期：</span>
              <span style="font-size:18px;">{{ ruleForm.date }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div>
              <span style="font-size:16px;">充值金额：</span>
              <span style="font-size:18px;">{{ ruleForm.amount }}</span>
            </div>
            <div>
              <span style="font-size:16px;">充值对象：</span>
              <span style="font-size:18px;">{{ ruleForm.target }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div>
              <span style="font-size:16px;">计费规则：</span>
              <v-icon style="color:#4caf50;cursor:pointer;" @click="addRule">mdi-plus-circle</v-icon>
            </div>
          </a-col>
        </a-row>
        <a-table size="small" :columns="rheaders" :data-source="ruleForm.rules" :pagination="false"
          :locale="{ emptyText: '暂无数据' }">
          <template slot="itype" slot-scope="text, record">
            <a-select v-model="record.itype" :options="itypes" placeholder="请选择" size="large" style="width:100%;"
              :disabled="saving">
            </a-select>
          </template>
          <template slot="type" slot-scope="text, record">
            <a-select v-model="record.type" :options="types" placeholder="请选择" size="large" style="width:100%;"
              :disabled="saving">
            </a-select>
          </template>
          <template slot="year_rate" slot-scope="text, record">
            <a-input v-model="record.year_rate" type="number" placeholder="费率" suffix="%" size="large"
              style="width:100%;" :disabled="saving" />
          </template>
          <template slot="start" slot-scope="text, record">
            <a-date-picker v-model="record.start" :locale="locale" :allowClear="false" format="YYYY-MM-DD"
              value-format="YYYY-MM-DD" placeholder="开始日期" size="large" style="width:100%;" :disabled="saving" />
          </template>
          <template slot="end" slot-scope="text, record">
            <a-date-picker v-model="record.end" :locale="locale" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
              placeholder="结束时间" size="large" style="width:100%;" :disabled="saving" />
          </template>
        </a-table>
      </a-form-model>
    </a-modal>
    <a-modal title="费用明细" :visible="detailModal" :footer="null" @cancel="() => detailModal = false">
      <a-table size="small" :columns="dheaders" :data-source="details" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: dwidth, y: 600 }" row-key="_id">

      </a-table>
    </a-modal>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "ZijinCostInterest",
  data() {
    return {
      locale,
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
        { text: '500/页', value: 500 },
        { text: '1000/页', value: 1000 },
      ],
      queryForm: {
        platform: "",
        days: [null, null],
        months: [this.$utils.moment().format('YYYY-MM'), this.$utils.moment().format('YYYY-MM')],
        target: "",
      },
      start_day_menu: false,
      end_day_menu: false,
      headers: [
        { title: "充值平台", dataIndex: "platform", slots: { title: "platform" }, scopedSlots: { customRender: "platform" }, width: 120, align: "center" },
        { title: "充值金额", dataIndex: "famount", slots: { title: "famount" }, scopedSlots: { customRender: "famount" }, width: 120, align: "center" },
        { title: "充值日期", dataIndex: "date", slots: { title: "date" }, scopedSlots: { customRender: "date" }, width: 120, align: "center" },
        { title: "充值对象", dataIndex: "target", slots: { title: "target" }, scopedSlots: { customRender: "target" }, width: 120, align: "center" },
        { title: "资金利息", dataIndex: "finterest", slots: { title: "finterest" }, scopedSlots: { customRender: "finterest" }, width: 120, align: "center" },
        { title: "资金成本", dataIndex: "fzijincost", slots: { title: "fzijincost" }, scopedSlots: { customRender: "fzijincost" }, width: 120, align: "center" },
        { title: "添加时间", dataIndex: "create_time", slots: { title: "create_time" }, scopedSlots: { customRender: "create_time" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", slots: { title: "action" }, scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      sheaders: [
        { title: "类型", dataIndex: "itype", slots: { title: "itype" }, scopedSlots: { customRender: "itype" }, width: 120, align: "center" },
        { title: "方式", dataIndex: "type", slots: { title: "type" }, scopedSlots: { customRender: "type" }, width: 120, align: "center" },
        { title: "年费率", dataIndex: "year_rate", slots: { title: "year_rate" }, scopedSlots: { customRender: "year_rate" }, width: 120, align: "center" },
        { title: "开始日期", dataIndex: "start", slots: { title: "start" }, scopedSlots: { customRender: "start" }, width: 120, align: "center" },
        { title: "结束日期", dataIndex: "end", slots: { title: "end" }, scopedSlots: { customRender: "end" }, width: 120, align: "center" },
        { title: "时长", dataIndex: "duration", slots: { title: "duration" }, scopedSlots: { customRender: "duration" }, width: 150, align: "center" },
        { title: "金额", dataIndex: "fee", slots: { title: "fee" }, scopedSlots: { customRender: "fee" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", slots: { title: "action" }, scopedSlots: { customRender: "action" }, width: 120, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      platforms: [],
      targets: [],
      modal: false,
      form: {},
      title: "",
      saving: false,
      rules: {
        platform: [
          { required: true, message: '充值平台不能为空', trigger: 'change' },
        ],
        amount: [
          { required: true, message: '充值金额不能为空', trigger: 'blur' },
        ],
        date: [
          { required: true, message: '充值日期不能为空', trigger: 'change' },
        ],
        target: [
          { required: true, message: '充值对象不能为空', trigger: 'change' },
        ],
      },
      ruleForm: {
        rules: [],
      },
      ruleModal: false,
      rheaders: [
        { title: "类型", dataIndex: "itype", slots: { title: "itype" }, scopedSlots: { customRender: "itype" }, width: 120, align: "center" },
        { title: "方式", dataIndex: "type", slots: { title: "type" }, scopedSlots: { customRender: "type" }, width: 120, align: "center" },
        { title: "年费率", dataIndex: "year_rate", slots: { title: "year_rate" }, scopedSlots: { customRender: "year_rate" }, width: 120, align: "center" },
        { title: "开始日期", dataIndex: "start", slots: { title: "start" }, scopedSlots: { customRender: "start" }, width: 120, align: "center" },
        { title: "结束日期", dataIndex: "end", slots: { title: "end" }, scopedSlots: { customRender: "end" }, width: 120, align: "center" },
      ],
      itypes: [
        { value: "in", label: "资金利息" },
        { value: "out", label: "资金成本" },
      ],
      types: [
        { value: "day", label: "按天" },
        { value: "month", label: "按月" },
      ],
      dheaders: [
        { title: "月份", dataIndex: "date", slots: { title: "date" }, scopedSlots: { customRender: "date" }, width: 120, align: "center" },
        { title: "金额", dataIndex: "fee", slots: { title: "fee" }, scopedSlots: { customRender: "fee" }, width: 120, align: "center" },
      ],
      details: [],
      detailModal: false,
      // total: {
      //   famount: 0,
      //   finterest: 0,
      //   fzijincost: 0,
      // },
      total: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    swidth() {
      return _.reduce(this.sheaders, (a, b) => a + (b.width || 300), 0);
    },
    dwidth() {
      return _.reduce(this.dheaders, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getData();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getData();
    },
  },
  mounted() {
    this.height = window.innerHeight - 380;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 380;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.queryForm = {
      platform: "",
      days: [null, null],
      months: [this.$utils.moment().format('YYYY-MM'), this.$utils.moment().format('YYYY-MM')],
      target: "",
    };
    this.getData();
  },
  methods: {
    changeMonth(value) {
      this.queryForm.months = [value[0].format('YYYY-MM'), value[1].format('YYYY-MM')];
    },
    changeMonthPanel(value, mode) {
      this.queryForm.months = [value[0].format('YYYY-MM'), value[1].format('YYYY-MM')];
      // this.mode = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
    },
    getData(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/zijincostinterest/list", {
        page: this.page,
        limit: this.limit,
        ...this.queryForm,
        action,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download') return this.$download(res.data.url, res.data.name);
          this.list = this.makelist(res.data.list);
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.platforms = res.data.platforms;
          this.targets = res.data.targets;
          this.total = res.data.total;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makelist(list) {
      let result = {
        amount: this.$utils.d(),
        interest: this.$utils.d(),
        zijincost: this.$utils.d(),
      };
      list = list.map(n => {
        result.amount = result.amount.plus(n.amount || 0);
        result.interest = result.interest.plus(n.interest || 0);
        result.zijincost = result.zijincost.plus(n.zijincost || 0);
        return {
          ...n,
          interests: n.interests.map(m => {
            return {
              ...m,
              fee: this.$utils.formatMoney(m.fee, 2, ''),
            };
          }),
          famount: this.$utils.formatMoney(n.amount, 2, ''),
          finterest: this.$utils.formatMoney(n.interest, 2, ''),
          fzijincost: this.$utils.formatMoney(n.zijincost, 2, ''),
        }
      });
      _.extend(result, {
        famount: this.$utils.formatMoney(result.amount.toString(), 2, ''),
        finterest: this.$utils.formatMoney(result.interest.toString(), 2, ''),
        fzijincost: this.$utils.formatMoney(result.zijincost.toString(), 2, ''),
      });
      // this.total = result;
      return list;
    },
    getInfo(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/zijincostinterest/info", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.form = res.data.formData;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    add() {
      this.title = "新增充值记录";
      this.getInfo().then(() => {
        this.modal = true;
      });
    },
    edit(_id) {
      this.title = "编辑充值记录";
      this.getInfo(_id).then(() => {
        this.modal = true;
      });
    },
    save() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // this.$toast.loading({ message: "" });
          this.saving = true;
          this.$api.doAPI("/zijincostinterest/save", { dataForm: this.form }).then((res) => {
            // this.$toast.clear();
            this.saving = false;
            if (res.code === 0) {
              this.modal = false;
              this.getData();
            } else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            // this.$toast.clear();
            this.saving = false;
            console.error(err);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelSave() {
      this.$refs.formRef.resetFields();
      this.modal = false;
    },
    getRuleInfo(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/zijincostinterest/ruleinfo", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.ruleForm = res.data.formData;
          this.ruleModal = true;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    addRule() {
      this.ruleForm.rules.push({
        itype: undefined,
        year_rate: "",
        type: undefined,
        start: undefined,
        end: undefined,
      });
    },
    saveRule() {
      this.$refs.ruleFormRef.validate(valid => {
        if (valid) {
          // this.$toast.loading({ message: "" });
          this.saving = true;
          this.$api.doAPI("/zijincostinterest/saverule", { dataForm: this.ruleForm }).then((res) => {
            // this.$toast.clear();
            this.saving = false;
            if (res.code === 0) {
              this.ruleModal = false;
              this.getData();
            } else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            // this.$toast.clear();
            this.saving = false;
            console.error(err);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelSaveRule() {
      this.$refs.ruleFormRef.resetFields();
      this.ruleModal = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/zijincostinterest/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getData();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showDetail(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/zijincostinterest/details", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.details = res.data.list;
          this.detailModal = true;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>